module.exports = __webpack_public_path__ + "static/cf-med-italic-ext-ecad03cd59336ba231fcbc334fa098fe.ttf";